import { UseQueryResult } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

export const useStreamFileDownload = (
  service: (id: string, enabled?: boolean) => UseQueryResult<Blob, Error>
) => {
  const [file, setFile] = useState<{
    id: string;
    name: string;
    extension?: string;
  } | null>();

  const streamedFile = service(file?.id ?? '', false);

  useEffect(() => {
    if (file?.id) {
      streamedFile.refetch();
      console.log(streamedFile.data);
    }
  }, [file?.id]);

  useEffect(() => {
    if (streamedFile.data && file) {
      const url = window.URL.createObjectURL(streamedFile.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${file.name}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setFile(null);
    }
  }, [streamedFile.data]);

  return { setFile };
};
